// src/constants/roles.ts
export const ROLES = {
  REGULAR: "regular",
  ACCOUNTANT: "accountant"
} as const;

export type UserRole = typeof ROLES[keyof typeof ROLES];

export const normalizeRole = (role: string): UserRole => {
  const normalized = role.toLowerCase();
  
  if (normalized === 'accountant') {
    return ROLES.ACCOUNTANT;
  }
  
  // По умолчанию или если не распознали - возвращаем regular
  return ROLES.REGULAR;
};